import { v4 } from "uuid";

export const getRandomId = (): string => v4();
